export const DOOH_REPORT_ADVERTISER = "DOOH_REPORT_ADVERTISER";
export const DOOH_REPORT_CAMPAIGN = "DOOH_REPORT_CAMPAIGN";
export const DOOH_REPORT_OUTLETS = "DOOH_REPORT_OUTLETS";
export const DOOH_REPORT_LOADER = "DOOH_REPORT_LOADER";

export const END_URL = {
    CAMPAIGN: '/dooh-report/summary/campaigns',
    ADVERTISERS : '/dooh-report/summary/advertisers',
    OUTLET: '/dooh-report/summary/outlets'
   
}